import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getCumulativeReportSuccess, getCumulativeReportFailure,
    getMyLabResultsSuccess, getMyLabResultsFailure,
    sendLabReportSuccess, sendLabReportFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* getCumulativeRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reports/patient/${action.payload}/cumulative`, requestDetail);
        yield put(getCumulativeReportSuccess(response));
    } catch (error) { yield put(getCumulativeReportFailure(error?.response?.message || error)); }
}

function* getMyLabResultsReq() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/patient/my-lab-results`, requestDetail);
        yield put(getMyLabResultsSuccess(response));
    } catch (error) { yield put(getMyLabResultsFailure(error?.response?.message || error)); }
}

function* sendReportRequest(action) {
    try {
        const { orderId, email } = action.payload;
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify({ email })
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/reports/order/${orderId}/send`, requestDetail);
        yield put(sendLabReportSuccess(response));
    } catch (error) { yield put(sendLabReportFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labReport/getCumulativeReportRequest', getCumulativeRequest);
    yield takeLatest('labReport/getMyLabResultsRequest', getMyLabResultsReq);
    yield takeLatest('labReport/sendLabReportRequest', sendReportRequest);
}

export default saga;
